import { render, staticRenderFns } from "./AdicionalesContainer.vue?vue&type=template&id=47fbc66f&scoped=true"
import script from "./AdicionalesContainer.vue?vue&type=script&lang=js"
export * from "./AdicionalesContainer.vue?vue&type=script&lang=js"
import style0 from "./AdicionalesContainer.vue?vue&type=style&index=0&id=47fbc66f&prod&scoped=true&lang=css"
import style1 from "./AdicionalesContainer.vue?vue&type=style&index=1&id=47fbc66f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fbc66f",
  null
  
)

export default component.exports